import { API } from '@xbto/api-client';
import { YearlyPerformance, YearlyPerformances } from '../../types';

export const enrichFundPerformances = (
  performances?: API.GetMonthlyFundPerformancesResponse | null
): YearlyPerformances | null => {
  if (!performances?.performances) {
    return null;
  }

  const grouped = {};
  performances.performances.forEach(item => {
    const { year, month, ...rest } = item;
    if (!grouped[year]) {
      grouped[year] = {};
    }
    grouped[year][month] = { month, ...rest };
  });
  performances.ytdPerformances?.forEach(item => {
    const { year, ...rest } = item;
    if (!grouped[year]) {
      grouped[year] = {};
    }
    grouped[year].ytd = { ...rest };
  });

  const result: YearlyPerformances = [];
  Object.keys(grouped).forEach(year => {
    const yearEntry = {
      year: parseInt(year),
      ytd: grouped[year].ytd || null,
    } as YearlyPerformance;

    for (let m = 1; m <= 12; m++) {
      yearEntry[m] = grouped[year][m] || null;
    }

    result.push(yearEntry);
  });
  return result;
};
